// js for shopable video
class ShopableVideo extends PopupBase {
  constructor() {
    super();
    this.popupDiv = this.querySelector(".video-item__popup");
    this.init();
  }
  init() {
    if (this.popupDiv || !this.classList.contains("instagram-item")) {
      window.addEventListener("resize", this.responsive.bind(this));
      window.addEventListener("load", this.responsive.bind(this));
      this.addEventListener("click", this.onClick.bind(this));
      this.connectedCallback();
    }
  }

  // FIX: Pause & mute all background section videos
  pauseAllSectionVideos() {
    const section = this.closest(".shopable-video-section");
    if (!section) return;
    const videos = section.querySelectorAll(".swiper-wrapper video");
    videos.forEach((video) => {
      video.pause();
      video.muted = true;
    });
  }

  // FIX: Resume background videos (muted autoplay) when popup closes
  resumeSectionVideos() {
    const section = this.closest(".shopable-video-section");
    if (!section) return;
    const videos = section.querySelectorAll(".swiper-wrapper video");
    videos.forEach((video) => {
      video.muted = true;
      // Only play if it has autoplay attribute
      if (video.hasAttribute("autoplay")) {
        video.play().catch(() => {});
      }
    });
  }

  onClick() {
    // FIX: Pause all background videos before opening popup
    this.pauseAllSectionVideos();

    const template = this.closest(".shopable-video-section").querySelector(
      "template"
    );
    if (template) {
      const content =
        template.content.firstElementChild.cloneNode(true).outerHTML;
      const nav = `<div class="swiper-arrow swiper-prev-modal transition swiper-button-prev bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
            <svg width="6" height="11" fill="none">
              <use href="#icon-back"></use>
            </svg>
          </div>
          <div class="swiper-arrow swiper-next-modal transition swiper-button-next bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
            <svg width="6" height="11" fill="none">
              <use href="#icon-next"></use>
            </svg>
          </div>`;
      this.initPopup(content, nav);
      this.findActiveSlideModal();
      const modal = this.modal;
      if (!modal) return;

      // FIX: When popup closes, resume background videos
      const originalClose = modal.modalCloseBtn;
      if (originalClose) {
        originalClose.addEventListener("click", () => {
          this.stopAllPopupVideos(modal);
          this.resumeSectionVideos();
        }, { once: true });
      }

      // FIX: Also listen for tingle close event
      if (modal.modal) {
        modal.modal.on && modal.modal.on("close", () => {
          this.stopAllPopupVideos(modal);
          this.resumeSectionVideos();
        });
      }

      const productPopupDiv = modal.modalBoxContent.querySelectorAll(
        ".video-item__product-mobile"
      );
      if (productPopupDiv.length > 0){
        productPopupDiv.forEach((div) => {
          div.addEventListener(
            "click",
            this.onClickMobile.bind(this)
          );
        });
      }

      // FIX: Handle slide change in popup - pause previous video, play current
      this.setupPopupSlideChange(modal);
    }
  }

  // FIX: Stop all videos inside popup modal
  stopAllPopupVideos(modal) {
    if (!modal || !modal.modalBoxContent) return;
    const popupVideos = modal.modalBoxContent.querySelectorAll("video");
    popupVideos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
    });
  }

  // FIX: On popup slide change, pause old video and play new one
  setupPopupSlideChange(modal) {
    if (!modal || !modal.modalBoxContent) return;
    const swiperContainer = modal.modalBoxContent.querySelector("slide-section-popup");
    if (!swiperContainer) return;

    const playActiveVideo = (swiper) => {
      // Pause all popup videos first
      const allVideos = swiperContainer.querySelectorAll("video");
      allVideos.forEach((v) => {
        v.pause();
        v.muted = true;
      });

      // Play only the active slide's video
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.muted = false;
        activeVideo.play().catch(() => {
          // If unmuted play fails (browser policy), try muted
          activeVideo.muted = true;
          activeVideo.play().catch(() => {});
        });
      }
    };

    // Wait for swiper to initialize
    const initCheck = setInterval(() => {
      if (swiperContainer.swiper) {
        clearInterval(initCheck);
        const swiper = swiperContainer.swiper;

        // Play current active slide video on open
        playActiveVideo(swiper);

        // On slide change
        swiper.on("slideChange", () => {
          playActiveVideo(swiper);
        });
      }
    }, 100);
  }

  findActiveSlideModal() {
    const modal = this.modal;
    if (!modal) return;
    const swiperContainer = modal.modalBoxContent.querySelector(
      "slide-section-popup"
    );
    if (!swiperContainer) return;
    const position = this.dataset.position;
    if (!position) return;
    if (position !== null && !isNaN(parseInt(position))) {
      const slideIndex = parseInt(position);
      swiperContainer.swiper.slideTo(slideIndex, 0, false);
    } else {
      swiperContainer.swiper.slideTo(0, 0, false);
    }
  }

  onCloseEvent() {
    const popup = document.querySelector(".tingle-modal.shopable-video");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    if (!productInformation) return;
    productInformation.classList.add("hidden");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const videos = this.querySelectorAll("video");
      videos.forEach((video) => {
        const dataSrc = video.dataset.src;
        if (dataSrc) {
          video.src = dataSrc;
          video.removeAttribute("data-src");
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }

  responsive() {
    const productDivs = document.querySelectorAll(
      ".shopable-video__product-information"
    );
    if (productDivs.length != 0) {
      if (window.innerWidth >= 768) {
        const flexDiv = this.popupDiv?.querySelector(
          ".video-item__popup--flex"
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.remove("hidden");
        });
      } else {
        const flexDiv = this.popupDiv?.querySelector(
          ".video-item__popup--flex"
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.add("hidden");
        });
      }
    }
  }

  onClickMobile(event) {
    const _this = this;
    const currentTarget = event.currentTarget;
    const popup = currentTarget.closest(".video-item__popup");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    if (!productInformation) return;
    const slidePopup = document.querySelector("slide-section-popup");
    slidePopup.swiper.allowTouchMove = false;
    slidePopup.swiper.unsetGrabCursor();
    productInformation.classList.remove("hidden");
    popup.classList.add("open");
    _this.modal.modalCloseBtn.style.display = "none";
  }
}
customElements.define("shopable-video", ShopableVideo);

class SlideSectionPopup extends SlideSection {
  constructor() {
    super();
  }
}
customElements.define("slide-section-popup", SlideSectionPopup);

class ShopableOverlay extends ShopableVideo {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    const currentTarget = event.currentTarget;
    const modal = currentTarget.closest(".shopable-video");
    const popup = currentTarget?.closest(".video-item__popup");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    const modalCloseBtn = modal?.querySelector(".tingle-modal__close");
    if (!productInformation) return;
    const slidePopup = document.querySelector("slide-section-popup");
    slidePopup.swiper.allowTouchMove = true;
    slidePopup.swiper.setGrabCursor();
    productInformation.classList.add("hidden");
    popup.classList.remove("open");
    modalCloseBtn.removeAttribute("style");
  }
}
customElements.define("shopable-overlay", ShopableOverlay);

class ButtonCloseShopable extends ShopableOverlay {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }
}
customElements.define("button-close-shopable", ButtonCloseShopable);